module.exports = __webpack_public_path__ + "img/log.eaeff3fb.png";